module.exports = __webpack_public_path__ + "img/bn.e7b3ef45.svg";